<template lang='pug'>
  div
    c-logout-action
</template>

<script>
  import cLogoutAction from '@/components/Logout'

  export default {
    components: { cLogoutAction },
    name: 'sidebar-footer'
  }
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarFooter.vue